"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animation = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _framerMotion = require("framer-motion");

const Container = _stylitas.styled.div``;
exports.Container = Container;
Container.Overlay = _stylitas.styled.div`
  position: fixed;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
`;
const Animation = (0, _stylitas.styled)(_framerMotion.motion.div)`
  height: 100%;
`;
exports.Animation = Animation;